import { render } from "./AuthoriseLogin.vue?vue&type=template&id=0cc6913a"
import script from "./AuthoriseLogin.vue?vue&type=script&lang=js"
export * from "./AuthoriseLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\identity_manager_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__